export const urls = {
    rootURL: process.env.REACT_APP_ROOT_URL || 'http://localhost:3000/',
    URL: process.env.REACT_APP_URL || 'http://localhost:3000/user-profile/',
    remoteURL: process.env.REACT_APP_REMOTE_URL || 'http://localhost:9000/api/',
    }
